import { FunctionComponent } from "react";
import { ROUTES } from "./constants";
import { Homepage } from "../pages/Home/Homepage";
import { Signin } from "../pages/Signin/Signin";
import { Signup } from "../pages/Signup/Signup";
import { ForgotPassword } from "../pages/ForgotPassword/ForgotPassword";
import { ResetPassword } from "../pages/ResetPassword/ResetPassword";
import { ChangePassword } from "../pages/ChangePassword/ChangePassword";
import { UserProfile } from "../pages/UserProfile/UserProfile";
import { UserInfo } from "../pages/UrserInfo/UserInfo";
import { EditUserProfile } from "../pages/EditUserProfile/EditUserProfile";
import { MyAppointments } from "../pages/MyAppointments/MyAppointments";
import { Dashboard } from "../pages/Dashboard/Dashboard";
import { Schedule } from "../pages/Schedule/Schedule";
import { DoctorProfile } from "../pages/DoctorProfile/DoctorProfile";
import { Reports } from "../pages/Reports/Reports";
import { UsersList } from "../pages/UsersList/UsersList";
import { AuditLogs } from "../pages/AuditLogs/AuditLogs";
import { Notifications } from "../pages/Notifications/Notifications";
import { Finance } from "../pages/Finance/Finance";
import { TermsOfUse } from "../pages/TermsOfUse/TermsOfUse";
import { PrivacyPolicy } from "../pages/PrivacyPolicy/PrivacyPolicy";
import { MedicalRecord } from "../pages/MedicalRecord/MedicalRecord";
import { PatientHistory } from "../pages/PatientHistory/PatientHistory";
import { MyMedicalRecords } from "../pages/MyMedicalRecords/MyMedicalRecords";
import { PrescriptionTemplatesManager } from "../pages/PrescriptionTemplatesManager/PrescriptionTemplatesManager";

export const AppRoutes: Record<string, FunctionComponent<any>> = {
  [ROUTES.HOME]: Homepage,
  [ROUTES.SIGNIN]: Signin,
  [ROUTES.SIGNUP]: Signup,
  [ROUTES.FORGOT_PASSWORD]: ForgotPassword,
  [ROUTES.RESET_PASSWORD]: ResetPassword,
  [ROUTES.CHANGE_PASSWORD]: ChangePassword,
  [ROUTES.USER_PROFILE]: UserProfile,
  [ROUTES.EDIT_PROFILE]: EditUserProfile,
  [ROUTES.EDIT_DOCTOR_PROFILE]: DoctorProfile,
  "/Usuario": UserInfo, // rota sem id mostra o próprio usuário (UserInfo trata isso)
  [ROUTES.USERINFO]: UserInfo,
  [ROUTES.MY_APPOINTMENTS]: MyAppointments,
  [ROUTES.DASHBOARD]: Dashboard,
  [ROUTES.SCHEDULE]: Schedule,
  [ROUTES.REPORTS]: Reports,
  [ROUTES.USERS_LIST]: UsersList,
  [ROUTES.AUDIT_LOGS]: AuditLogs,
  [ROUTES.NOTIFICATIONS]: Notifications,
  [ROUTES.FINANCE]: Finance,
  [ROUTES.TERMS_OF_USE]: TermsOfUse,
  [ROUTES.PRIVACY_POLICY]: PrivacyPolicy,
  [ROUTES.MEDICAL_RECORD_NEW]: MedicalRecord,
  [ROUTES.MEDICAL_RECORD]: MedicalRecord,
  [ROUTES.PATIENT_HISTORY]: PatientHistory,
  [ROUTES.MY_MEDICAL_RECORDS]: MyMedicalRecords,
  [ROUTES.PRESCRIPTION_TEMPLATES]: PrescriptionTemplatesManager,
};
